import React from 'react';
import "./Handler.scss";

const Handler = () => {
  return (
    <div className="handler">
        <span className="handler--shape"></span>
    </div>
  )
}

export default Handler
